import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "create__statements"
}
const _hoisted_2 = { class: "white__navbar" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "/", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 5 }
const _hoisted_10 = { key: 6 }
const _hoisted_11 = { key: 7 }
const _hoisted_12 = { key: 8 }
const _hoisted_13 = { key: 9 }
const _hoisted_14 = { key: 10 }
const _hoisted_15 = { key: 11 }
const _hoisted_16 = { key: 12 }
const _hoisted_17 = { class: "create__statements__content" }
const _hoisted_18 = {
  key: 1,
  class: "create__statements"
}
const _hoisted_19 = { class: "white__navbar" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "/", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { key: 4 }
const _hoisted_26 = { key: 5 }
const _hoisted_27 = { key: 6 }
const _hoisted_28 = { class: "create__statements__content" }
const _hoisted_29 = {
  key: 2,
  class: "create__statements"
}
const _hoisted_30 = { class: "white__navbar" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, "/", -1)
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { key: 3 }
const _hoisted_36 = { key: 4 }
const _hoisted_37 = { key: 5 }
const _hoisted_38 = { key: 6 }
const _hoisted_39 = { class: "create__statements__content" }
const _hoisted_40 = {
  key: 3,
  class: "create__statements"
}
const _hoisted_41 = { class: "white__navbar" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, "/", -1)
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { key: 3 }
const _hoisted_47 = { key: 4 }
const _hoisted_48 = { key: 5 }
const _hoisted_49 = { key: 6 }
const _hoisted_50 = { key: 7 }
const _hoisted_51 = { class: "create__statements__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_One = _resolveComponent("One")!
  const _component_Second = _resolveComponent("Second")!
  const _component_Third = _resolveComponent("Third")!
  const _component_ThirdProxy = _resolveComponent("ThirdProxy")!
  const _component_Fourth = _resolveComponent("Fourth")!
  const _component_FourthTwo = _resolveComponent("FourthTwo")!
  const _component_Fifth = _resolveComponent("Fifth")!
  const _component_Sixth = _resolveComponent("Sixth")!
  const _component_Seventh = _resolveComponent("Seventh")!
  const _component_EigthTwo = _resolveComponent("EigthTwo")!
  const _component_Nineth = _resolveComponent("Nineth")!
  const _component_Tenth = _resolveComponent("Tenth")!
  const _component_Eleventh = _resolveComponent("Eleventh")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_InfoOtherOne = _resolveComponent("InfoOtherOne")!
  const _component_InfoOtherTwo = _resolveComponent("InfoOtherTwo")!
  const _component_InfoOtherThree = _resolveComponent("InfoOtherThree")!
  const _component_InfoOtherFour = _resolveComponent("InfoOtherFour")!
  const _component_InfoOtherFive = _resolveComponent("InfoOtherFive")!
  const _component_InfoOtherSix = _resolveComponent("InfoOtherSix")!
  const _component_InfoOtherSeven = _resolveComponent("InfoOtherSeven")!
  const _component_InfoSurgutOne = _resolveComponent("InfoSurgutOne")!
  const _component_InfoSurgutTwo = _resolveComponent("InfoSurgutTwo")!
  const _component_InfoSurgutThree = _resolveComponent("InfoSurgutThree")!
  const _component_InfoSurgutFour = _resolveComponent("InfoSurgutFour")!
  const _component_InfoSurgutFive = _resolveComponent("InfoSurgutFive")!
  const _component_InfoSurgutSix = _resolveComponent("InfoSurgutSix")!
  const _component_InfoSurgutSeven = _resolveComponent("InfoSurgutSeven")!
  const _component_InfoMskOOne = _resolveComponent("InfoMskOOne")!
  const _component_InfoMskOTwo = _resolveComponent("InfoMskOTwo")!
  const _component_InfoMskOThree = _resolveComponent("InfoMskOThree")!
  const _component_InfoMskOFour = _resolveComponent("InfoMskOFour")!
  const _component_InfoMskOFourOne = _resolveComponent("InfoMskOFourOne")!
  const _component_InfoMskOFourTwo = _resolveComponent("InfoMskOFourTwo")!
  const _component_InfoMskOFive = _resolveComponent("InfoMskOFive")!
  const _component_InfoMskOSix = _resolveComponent("InfoMskOSix")!
  const _component_ModalSkip = _resolveComponent("ModalSkip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.document.prefix =='spb' && _ctx.document.postfix =='info')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", null, "Заявление №" + _toDisplayString(_ctx.docID), 1),
            _hoisted_3,
            (_ctx.page == 1)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Тип заявителя / Выбор типа заявителя"))
              : _createCommentVNode("", true),
            (_ctx.page == 2)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Выбор способа подачи"))
              : _createCommentVNode("", true),
            (_ctx.page == 3 && _ctx.document.send_type == 2)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Самостоятельно"))
              : _createCommentVNode("", true),
            (_ctx.page == 3 && _ctx.document.send_type != 2)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Информация о заявителе"))
              : _createCommentVNode("", true),
            (_ctx.page == 4)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Адрес местности"))
              : _createCommentVNode("", true),
            (_ctx.page == 5)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Установка карты"))
              : _createCommentVNode("", true),
            (_ctx.page == 6)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Информация о конструкции"))
              : _createCommentVNode("", true),
            (_ctx.page == 7)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Фотофиксация перспективы конструкции"))
              : _createCommentVNode("", true),
            (_ctx.page == 8)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Компьютерный монтаж перспективы конструкции"))
              : _createCommentVNode("", true),
            (_ctx.page == 9)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Эскизный проект"))
              : _createCommentVNode("", true),
            (_ctx.page == 10)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Данные о конструкции"))
              : _createCommentVNode("", true),
            (_ctx.page == 11)
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Данные о проектировщие и изготовителе"))
              : _createCommentVNode("", true),
            (_ctx.page == 12)
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Сохранение заявления"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.page == 1)
              ? (_openBlock(), _createBlock(_component_One, {
                  key: 0,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 2)
              ? (_openBlock(), _createBlock(_component_Second, {
                  key: 1,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 3 && _ctx.document.send_type == 2)
              ? (_openBlock(), _createBlock(_component_Third, {
                  key: 2,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 3 && _ctx.document.send_type != 2)
              ? (_openBlock(), _createBlock(_component_ThirdProxy, {
                  key: 3,
                  document: _ctx.document,
                  onEditProxy: _ctx.edit_proxy,
                  onEditSignatory: _ctx.edit_signatory
                }, null, 8, ["document", "onEditProxy", "onEditSignatory"]))
              : _createCommentVNode("", true),
            (_ctx.page == 4)
              ? (_openBlock(), _createBlock(_component_Fourth, {
                  key: 4,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 5)
              ? (_openBlock(), _createBlock(_component_FourthTwo, {
                  key: 5,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 6)
              ? (_openBlock(), _createBlock(_component_Fifth, {
                  key: 6,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 7)
              ? (_openBlock(), _createBlock(_component_Sixth, {
                  key: 7,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 8)
              ? (_openBlock(), _createBlock(_component_Seventh, {
                  key: 8,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 9)
              ? (_openBlock(), _createBlock(_component_EigthTwo, {
                  key: 9,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 10)
              ? (_openBlock(), _createBlock(_component_Nineth, {
                  key: 10,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 11)
              ? (_openBlock(), _createBlock(_component_Tenth, {
                  key: 11,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 12)
              ? (_openBlock(), _createBlock(_component_Eleventh, {
                  key: 12,
                  document: _ctx.document,
                  onChangePage: _ctx.change_page
                }, null, 8, ["document", "onChangePage"]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(), _createBlock(_component_pagination, {
            modelValue: _ctx.page,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
            onModalskip: _ctx.modalskip_show,
            check_next: _ctx.check_next,
            doc_type: 'statement',
            key: _ctx.pagination_key,
            onClick: _ctx.update_page_query,
            style: _normalizeStyle('left: '+_ctx.pagination_bottom_left+' transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);'),
            page_arr: [
        {name: '1', title: 'Тип заявителя', complete: ['client_inn']},
        {name: '2', title: 'Способ подачи', complete: ['send_type']},
        {name: '3', title: 'Настройка доверенности', complete: ['proxy_id']},
        {name: '4', title: 'Адрес местности', complete: ['map_address','map_district','map_street']},
        {name: '5', title: 'Карта местности', complete: ['mapfile_type','map_file','map_yandex_file']},
        {name: '6', title: 'Информация о конструкции', complete: ['place_install','construction_type']},
        {name: '7', title: 'Фотофиксация', complete: ['construction_perspective_file','construction_around_file','construction_away_file']},
        {name: '8', title: 'Компьютерный монтаж', complete: ['comp_arr']},
        {name: '9', title: 'Эскизный проект', complete: ['sketch_arr']},
        {name: '10', title: 'Подсветка', complete: ['construction_width','construction_height']},
        {name: '11', title: 'Проектировщик и изготовитель', complete: ['designer_name','manufacturer_name']},
        {name: '12', title: 'Сохранение заявления', complete: []}
      ],
            nav_btn: true,
            page: _ctx.page,
            document: _ctx.document,
            onChangePage: _ctx.change_page
          }, null, 8, ["modelValue", "onModalskip", "check_next", "onClick", "style", "page", "document", "onChangePage"]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.document.prefix =='other' && _ctx.document.postfix =='info')
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("p", null, "Заявление №" + _toDisplayString(_ctx.docID), 1),
            _hoisted_20,
            (_ctx.page == 1)
              ? (_openBlock(), _createElementBlock("p", _hoisted_21, "Титульный лист"))
              : _createCommentVNode("", true),
            (_ctx.page == 2)
              ? (_openBlock(), _createElementBlock("p", _hoisted_22, "Информация о здании и конструкции"))
              : _createCommentVNode("", true),
            (_ctx.page == 3)
              ? (_openBlock(), _createElementBlock("p", _hoisted_23, "Карта местности"))
              : _createCommentVNode("", true),
            (_ctx.page == 4)
              ? (_openBlock(), _createElementBlock("p", _hoisted_24, "Фотофиксация конструкции"))
              : _createCommentVNode("", true),
            (_ctx.page == 5)
              ? (_openBlock(), _createElementBlock("p", _hoisted_25, "Эскизный проект"))
              : _createCommentVNode("", true),
            (_ctx.page == 6)
              ? (_openBlock(), _createElementBlock("p", _hoisted_26, "Компьютерный монтаж"))
              : _createCommentVNode("", true),
            (_ctx.page == 7)
              ? (_openBlock(), _createElementBlock("p", _hoisted_27, "Сохранение заявления"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_28, [
            (_ctx.page == 1)
              ? (_openBlock(), _createBlock(_component_InfoOtherOne, {
                  key: 0,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 2)
              ? (_openBlock(), _createBlock(_component_InfoOtherTwo, {
                  key: 1,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 3)
              ? (_openBlock(), _createBlock(_component_InfoOtherThree, {
                  key: 2,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 4)
              ? (_openBlock(), _createBlock(_component_InfoOtherFour, {
                  key: 3,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 5)
              ? (_openBlock(), _createBlock(_component_InfoOtherFive, {
                  key: 4,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 6)
              ? (_openBlock(), _createBlock(_component_InfoOtherSix, {
                  key: 5,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 7)
              ? (_openBlock(), _createBlock(_component_InfoOtherSeven, {
                  key: 6,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(), _createBlock(_component_pagination, {
            modelValue: _ctx.page,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.page) = $event)),
            onModalskip: _ctx.modalskip_show,
            check_next: _ctx.check_next,
            doc_type: 'statement',
            key: _ctx.pagination_key,
            onClick: _ctx.update_page_query,
            style: _normalizeStyle('left: '+_ctx.pagination_bottom_left+' transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);'),
            page_arr: [
        {name: '1', title: 'Титульный лист', complete: ['purpose_design','address','address_law','designer_name']},
        {name: '2', title: 'Информация о здании и конструкции', complete: ['purpose_building','binding','construction_info','place','size','info_front','info_light','info_side','info_back']},
        {name: '3', title: 'Карта местности', complete: ['mapfile_type','map_file','map_yandex_file']},
        {name: '4', title: 'Фотофиксация конструкции', complete: ['construction_around_file','construction_away_file']},
        {name: '5', title: 'Эскизный проект', complete: ['sketch_project_one_file']},
        {name: '6', title: 'Компьютерный монтаж', complete: ['mounting_around_file','mounting_away_file']},
        {name: '7', title: 'Сохранение заявления', complete: []}
      ],
            nav_btn: true,
            page: _ctx.page,
            document: _ctx.document,
            onChangePage: _ctx.change_page
          }, null, 8, ["modelValue", "onModalskip", "check_next", "onClick", "style", "page", "document", "onChangePage"]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.document.prefix =='surgut' && _ctx.document.postfix =='info')
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("p", null, "Заявление №" + _toDisplayString(_ctx.docID), 1),
            _hoisted_31,
            (_ctx.page == 1)
              ? (_openBlock(), _createElementBlock("p", _hoisted_32, "Титульный лист"))
              : _createCommentVNode("", true),
            (_ctx.page == 2)
              ? (_openBlock(), _createElementBlock("p", _hoisted_33, "Список подписантов"))
              : _createCommentVNode("", true),
            (_ctx.page == 3)
              ? (_openBlock(), _createElementBlock("p", _hoisted_34, "Ситуационная схема"))
              : _createCommentVNode("", true),
            (_ctx.page == 4)
              ? (_openBlock(), _createElementBlock("p", _hoisted_35, "Фотофиксация конструкции"))
              : _createCommentVNode("", true),
            (_ctx.page == 5)
              ? (_openBlock(), _createElementBlock("p", _hoisted_36, "Эскизный проект"))
              : _createCommentVNode("", true),
            (_ctx.page == 6)
              ? (_openBlock(), _createElementBlock("p", _hoisted_37, "Архитектурно-художественная подсветка"))
              : _createCommentVNode("", true),
            (_ctx.page == 7)
              ? (_openBlock(), _createElementBlock("p", _hoisted_38, "Сохранение заявления"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_39, [
            (_ctx.page == 1)
              ? (_openBlock(), _createBlock(_component_InfoSurgutOne, {
                  key: 0,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 2)
              ? (_openBlock(), _createBlock(_component_InfoSurgutTwo, {
                  key: 1,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 3)
              ? (_openBlock(), _createBlock(_component_InfoSurgutThree, {
                  key: 2,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 4)
              ? (_openBlock(), _createBlock(_component_InfoSurgutFour, {
                  key: 3,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 5)
              ? (_openBlock(), _createBlock(_component_InfoSurgutFive, {
                  key: 4,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 6)
              ? (_openBlock(), _createBlock(_component_InfoSurgutSix, {
                  key: 5,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 7)
              ? (_openBlock(), _createBlock(_component_InfoSurgutSeven, {
                  key: 6,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(), _createBlock(_component_pagination, {
            modelValue: _ctx.page,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.page) = $event)),
            onModalskip: _ctx.modalskip_show,
            check_next: _ctx.check_next,
            doc_type: 'statement',
            key: _ctx.pagination_key,
            onClick: _ctx.update_page_query,
            style: _normalizeStyle('left: '+_ctx.pagination_bottom_left+' transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);'),
            page_arr: [
        {name: '1', title: 'Титульный лист', complete: ['designer_name','address','address_law','purpose_design']},
        {name: '2', title: 'Список подписантов', complete: ['employee1_name','employee1_id']},
        {name: '3', title: 'Карта местности', complete: ['mapfile_type','map_file','map_yandex_file']},
        {name: '4', title: 'Фотофиксация конструкции', complete: ['photo_old_file','photo_new_file']},
        {name: '5', title: 'Эскизный проект', complete: ['sketch_count']},
        {name: '6', title: 'Подсветка вывески', complete: ['lighting_file']},
        {name: '7', title: 'Сохранение заявления', complete: []}
      ],
            nav_btn: true,
            page: _ctx.page,
            document: _ctx.document,
            onChangePage: _ctx.change_page
          }, null, 8, ["modelValue", "onModalskip", "check_next", "onClick", "style", "page", "document", "onChangePage"]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.document.prefix =='msk_o' && _ctx.document.postfix =='info')
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("p", null, "Заявление №" + _toDisplayString(_ctx.docID), 1),
            _hoisted_42,
            (_ctx.page == 1)
              ? (_openBlock(), _createElementBlock("p", _hoisted_43, "Адрес местности"))
              : _createCommentVNode("", true),
            (_ctx.page == 2)
              ? (_openBlock(), _createElementBlock("p", _hoisted_44, "Информация о владельце конструкции"))
              : _createCommentVNode("", true),
            (_ctx.page == 3)
              ? (_openBlock(), _createElementBlock("p", _hoisted_45, "Карта местности"))
              : _createCommentVNode("", true),
            (_ctx.page == 4)
              ? (_openBlock(), _createElementBlock("p", _hoisted_46, "Фотофиксация конструкции"))
              : _createCommentVNode("", true),
            (_ctx.page == 5)
              ? (_openBlock(), _createElementBlock("p", _hoisted_47, "Чертёж средства размещения информации"))
              : _createCommentVNode("", true),
            (_ctx.page == 6)
              ? (_openBlock(), _createElementBlock("p", _hoisted_48, "Монтаж конструкции"))
              : _createCommentVNode("", true),
            (_ctx.page == 7)
              ? (_openBlock(), _createElementBlock("p", _hoisted_49, "Эскизный проект"))
              : _createCommentVNode("", true),
            (_ctx.page == 8)
              ? (_openBlock(), _createElementBlock("p", _hoisted_50, "Сохранение заявления"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_51, [
            (_ctx.page == 1)
              ? (_openBlock(), _createBlock(_component_InfoMskOOne, {
                  key: 0,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 2)
              ? (_openBlock(), _createBlock(_component_InfoMskOTwo, {
                  key: 1,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 3)
              ? (_openBlock(), _createBlock(_component_InfoMskOThree, {
                  key: 2,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 4)
              ? (_openBlock(), _createBlock(_component_InfoMskOFour, {
                  key: 3,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 5)
              ? (_openBlock(), _createBlock(_component_InfoMskOFourOne, {
                  key: 4,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 6)
              ? (_openBlock(), _createBlock(_component_InfoMskOFourTwo, {
                  key: 5,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 7)
              ? (_openBlock(), _createBlock(_component_InfoMskOFive, {
                  key: 6,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true),
            (_ctx.page == 8)
              ? (_openBlock(), _createBlock(_component_InfoMskOSix, {
                  key: 7,
                  document: _ctx.document
                }, null, 8, ["document"]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(), _createBlock(_component_pagination, {
            modelValue: _ctx.page,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page) = $event)),
            onModalskip: _ctx.modalskip_show,
            check_next: _ctx.check_next,
            doc_type: 'statement',
            key: _ctx.pagination_key,
            onClick: _ctx.update_page_query,
            style: _normalizeStyle('left: '+_ctx.pagination_bottom_left+' transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);'),
            page_arr: [
        {name: '1', title: 'Адрес местности', complete: ['address','characteristics_info','characteristics_building']},
        {name: '2', title: 'Информация о владельце', complete: ['information_owner','address','size','information_text']},
        {name: '3', title: 'Карта местности', complete: ['mapfile_type','map_file','map_yandex_file']},
        {name: '4', title: 'Фотофиксация конструкции', complete: ['construction_around_file','construction_away_file']},
        {name: '5', title: 'Чертёж', complete: ['sketchmini_file']},
        {name: '6', title: 'Фотомонтаж конструкции', complete: ['mounting_around_file','mounting_away_file']},
        {name: '7', title: 'Эскизный проект', complete: ['sketch_file']},
        {name: '8', title: 'Сохранение заявления', complete: []}
      ],
            nav_btn: true,
            page: _ctx.page,
            document: _ctx.document,
            onChangePage: _ctx.change_page
          }, null, 8, ["modelValue", "onModalskip", "check_next", "onClick", "style", "page", "document", "onChangePage"]))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_component_ModalSkip, {
      key: _ctx.modalskip_key,
      is_open: _ctx.modalskip_open,
      info_num: '0',
      onSkip_btn: _ctx.skip_btn,
      onUnskip_change: _ctx.unskip_change
    }, null, 8, ["is_open", "onSkip_btn", "onUnskip_change"]))
  ], 64))
}